export enum OperatorEnum {
  ADD = "+",
  SUBTRACT = "-",
  MULTIPLY = "x",
  DIVIDE = "÷",
}

// Color enums:

export enum ColorsEnum {
  RED = "red",
  GREEN = "green",
  WHITE = "white",
  CHOSEN_RED = "#ef7979",
  CHOSEN_GREEN = "#26bba2",
  CHOSEN_WHITE = "#fcfcfc",
}

export enum DarkThemeEnum {
  FONT_DARK_COLOR = "#fcfcfc",
  DISPLAY_DARK_COLOR = "#22252d",
  KEYBOARD_DARK_COLOR = "#292d36",
  BUTTON_DARK_COLOR = "#272b33",
  BUTTON_HOVER_DARK_COLOR = "#fcfcfc",
}

export enum LightThemeEnum {
  FONT_LIGHT_COLOR = "black",
  DISPLAY_LIGHT_COLOR = "white",
  KEYBOARD_LIGHT_COLOR = "#F9F9F9",
  BUTTON_LIGHT_COLOR = "#F7F7F7",
}
